/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { JobRunnerService } from 'apps/configuration/src/Services/job-runner';
import { create } from 'zustand';

/**
 * The definition of state-controlled settings for the job runner service.
 * @export
 * @interface JobRunnerServiceStore
 */
export interface JobRunnerServiceStore {
  jobRunnerService: JobRunnerService | null;
  updateJobRunnerService: (newValue: JobRunnerService | null) => void;
}

/**
 * The state store for the job runner service.
 */
export const useJobRunnerServiceStore = create<JobRunnerServiceStore>()((set) => ({
  jobRunnerService: null,
  updateJobRunnerService: (newValue: JobRunnerService | null): void => {
    set({ jobRunnerService: newValue });
  },
}));
